import MuiBox from '@mui/material/Box';
import React, { useEffect, useLayoutEffect, useState } from 'react';
import useMyMApi from "../../hooks/useMyMApi";
import { MyMProgress } from '../../ui-elements/MyMProgress';

export const previewModalSize = {
  width: '80%',
  height: '80%'
};

/**
 * Preview Component
 */
const Preview = (props) => {

  const screenId = 'MyM906';
  const [previewLoaded, setPreviewLoaded] = useState(false);
  const apiRequest = useMyMApi(screenId);

  useLayoutEffect(() => {

    // UI ElementsのPreviewJSとCSSを読み込み
    const css = document.createElement('link');
    css.rel = 'stylesheet'
    css.type = 'text/css'
    // 2024.5.8 MyMine Version1.5対応 Modify Start
    css.href = 'https://cdn01.boxcdn.net/platform/preview/2.106.0/en-US/preview.css'
    // 2024.5.8 MyMine Version1.5対応 Modify End
    document.head.appendChild(css);

    const script = document.createElement('script');
    // 2024.5.8 MyMine Version1.5対応 Modify Start
    script.src = 'https://cdn01.boxcdn.net/platform/preview/2.106.0/en-US/preview.js';
    // 2024.5.8 MyMine Version1.5対応 Modify End
    document.head.appendChild(script);
    return () => {
      document.head.removeChild(script);
      document.head.removeChild(css);
    }
  }, []);

  useEffect(() => {

    /**
     * MyMineプレビューリクエストコールバック処理
     * @param {any} result
     */
    const callbackRequestPreview = (result) => {

      /*global Box*/
      /*eslint no-undef: "error"*/

      // Contents Preview組み立て
      var preview = new Box.Preview();
      preview.show(
        props.fileId,
        result.Token,
        {
          container: '.preview-container',
          header: 'light',
          showAnnotations: false,
          showDownload: true,
          logoUrl: `${process.env.PUBLIC_URL}/${screenId}/preview-logo.png`
        });

      preview.addListener("load", data => {
        // ダウンロードクリックイベントを捕捉
        document.querySelectorAll('[data-testid=download-preview], [data-testid=preview-error-download-btn]').forEach((elem) => {
          elem.addEventListener("click", function () {
            onDownload();
          });
        });
      });

      setPreviewLoaded(true);
    };

    /**
     * MyMineプレビューリクエスト失敗コールバック処理
     * @param {any} result
     */
    const callbackRequestPreviewFailed = () => {
      props.onPreviewFailed();
    };

    // MyMineプレビューリクエスト
    const param = { FileId: props.fileId };
    apiRequest.requestJson('api/box-file/preview', 'POST', callbackRequestPreview, callbackRequestPreviewFailed, param);
  }, []);

  /**
   * プレビュー上のダウンロード押下処理
   */
  const onDownload = () => {
    const param = { FileId: props.fileId };
    apiRequest.requestJson('api/box-file/download-for-preview', 'POST', null, null, param);
  }

  if (!previewLoaded) {
    return <MyMProgress />
  }

  return (
    <>
      <MuiBox className="preview-container h-100 lh-1" />
    </>
  )
}
export default Preview;